import { Component, OnInit } from '@angular/core';
import { User } from '../../../model/user.model';
import { NgForm } from '@angular/forms';
import { UserService } from '../../../services/user/user.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-siteuseradd',
  templateUrl: './siteuseradd.component.html',
  styleUrls: ['./siteuseradd.component.css']
})
export class SiteuseraddComponent implements OnInit {

  user : User;
  isLoading : boolean = false;
  isRegisterSuccess : boolean = false;
  isRegisterFailure : boolean = false;

  selecteduserstatus: string;

  userstatusoptions = [
    { name: "Inactive", value: "inactive" },
    { name: "Active", value: "active" }
  ]

  constructor(private userService : UserService, private router: Router) { }

  ngOnInit() {
    this.resetForm();
  }

  resetForm(form? : NgForm)
  {
    if(form != null)
    form.reset();
    this.user = new User;
    // this.user={
    //   Email : '',
    //   Password : '',
    //   ConfirmPassword : '',
    //   PhoneNumber : '',
    //   Address : '',
    //   userType : '',
    //   FullName : '',
    //   VendorCode : '',
    //   type : '',
    //   IsActive : '',
    //   CreatedBy : '',
    //   CreatedOn : '',
    //   UpdatedBy : '',
    //   UpdatedOn : '',
    //   RegisterCode : '',
    //   Error : '',
    //   changesAllow : false
    // }
  }

  OnSubmit(form : NgForm)
  {
    this.isLoading = true;
    this.isRegisterFailure = false;
    this.isRegisterSuccess = false;
    this.userService.registerUser(form.value)
      .subscribe((data : any) => {
          if(data == true)
          {
            this.resetForm(form);
            this.isLoading = false;
            this.isRegisterSuccess = true;
          }
          else
          {
            this.isLoading = false;
            this.isRegisterFailure = true;
          }
      });
  }



}
